// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import PartReturns, {getDefaultState as getPartReturnsDefaultState} from '../../shared/state/part-returns';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const OpenPartRequestsState = t.struct({
    busyCounter: BusyCounter,
    facets: Facets,
    partReturns: PartReturns,
    searchFilters: SearchFilters
}, 'OpenPartRequestsState');

export const getDefaultState = () =>
    new OpenPartRequestsState({
        busyCounter: getBusyCounterDefaultState(),
        facets: getFacetsDefaultState(),
        partReturns: getPartReturnsDefaultState(),
        searchFilters: getSearchFiltersDefaultState()
    });

export default OpenPartRequestsState;



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/state/index.js